"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VariantSwitch;
var _react = _interopRequireDefault(require("react"));
var _Variant = _interopRequireDefault(require("./Variant.context"));
var _Variant2 = require("./Variant.utils");
function VariantSwitch(props) {
  // like react router's switch component, only the first match shows
  return /*#__PURE__*/_react.default.createElement(_Variant.default.Consumer, null, variants => renderFirstMatchingChild(props.children, variants));
  function renderFirstMatchingChild(children, variants) {
    let result = null;
    for (let i = 0; i < children.length; i++) {
      // if child is a VariantOption, check if its `which` property matches one of the variants
      const child = children[i];
      if (child.type && child.type.uglifiedSafeName === "VariantOption") {
        if (child.props && child.props.which && (0, _Variant2.doesVariantMatch)(child.props.which, variants)) {
          result = child;
          break;
        }
      }
    }
    return result;
  }
}